import { stanceTopics } from '@/mocks/home';

const trendMeta: Record<string, { icon: string; cls: string }> = {
  up: { icon: 'ri-arrow-up-line', cls: 'text-primary-600' },
  down: { icon: 'ri-arrow-down-line', cls: 'text-accent-700' },
  flat: { icon: 'ri-subtract-line', cls: 'text-foreground-500' },
};

export default function StanceBoard() {
  return (
    <section id="stance" className="py-16 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-10">
        <div className="max-w-2xl mb-12">
          <span className="font-label text-xs tracking-[0.3em] text-primary-600">STANCE BOARD</span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3">
            网友站队情况
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed">
            同一件事，支持、质疑与中立各占多少？把这三条比例摆在一起，比只看哪边嗓门大要靠得住得多。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          {stanceTopics.map((topic) => {
            const trend = trendMeta[topic.trend] ?? trendMeta.flat;
            return (
              <article
                key={topic.title}
                className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 flex flex-col"
              >
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">
                    {topic.title}
                  </h3>
                  <span className="shrink-0 px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-label">
                    {topic.heat}
                  </span>
                </div>

                <div className="flex h-2.5 rounded-full overflow-hidden mt-6 bg-background-200">
                  <span className="bg-primary-500" style={{ width: `${topic.support}%` }} />
                  <span className="bg-accent-500" style={{ width: `${topic.doubt}%` }} />
                  <span className="bg-secondary-300" style={{ width: `${topic.neutral}%` }} />
                </div>

                <div className="flex flex-col gap-3 mt-6">
                  <div className="flex items-center justify-between text-sm">
                    <span className="flex items-center gap-2 text-foreground-700">
                      <span className="w-2.5 h-2.5 rounded-full bg-primary-500" />
                      支持
                    </span>
                    <span className="font-heading font-bold text-foreground-950">
                      {topic.support}%
                    </span>
                  </div>
                  <div className="flex items-center justify-between text-sm">
                    <span className="flex items-center gap-2 text-foreground-700">
                      <span className="w-2.5 h-2.5 rounded-full bg-accent-500" />
                      质疑
                    </span>
                    <span className="font-heading font-bold text-foreground-950">
                      {topic.doubt}%
                    </span>
                  </div>
                  <div className="flex items-center justify-between text-sm">
                    <span className="flex items-center gap-2 text-foreground-700">
                      <span className="w-2.5 h-2.5 rounded-full bg-secondary-300" />
                      中立
                    </span>
                    <span className="font-heading font-bold text-foreground-950">
                      {topic.neutral}%
                    </span>
                  </div>
                </div>

                <div className="mt-6 pt-4 border-t border-background-200/70 flex items-center justify-between">
                  <span className={`flex items-center gap-1 text-xs font-label ${trend.cls}`}>
                    <i className={trend.icon} />
                    {topic.trendText}
                  </span>
                  <span className="text-xs text-foreground-500 font-label">
                    样本 {topic.total.toLocaleString()}
                  </span>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}